export default "__VITE_ASSET__DiCMMOn2__"